import _ from 'lodash'
import { useSelector } from 'react-redux'
import { useMemo } from 'react'

import { getLocalCountries } from '../redux/config'

import { useCountries } from './useCountries'

export const useCountriesForPreferredProducts = (skip?: boolean) => {
  const { countries, countriesLoading } = useCountries(skip)

  const allowedCountries = useSelector(getLocalCountries)

  const filteredCountries = useMemo(
    () => _.filter(countries, c => _.size(allowedCountries) === 0 || _.includes(allowedCountries, c.code)),
    [allowedCountries, countries]
  )

  return { countries: filteredCountries, countriesLoading }
}
